<template>
    <div class="position_page_div full-page">
        <EvalPosition></EvalPosition>
    </div>
</template>
<script type="text/javascript">
import EvalPosition from '@/components/eval_page/position_target.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        EvalPosition
    },
    methods: {
        ...mapActions({

        })
    },
    mounted: async function () {

    }
}
</script>
<style type="text/css">
    .position_page_div{
        background: url("/static/img/bg_e_1.png") no-repeat;
    }
</style>
